export default __webpack_public_path__ + "static/media/no-profile-image.0de04467.png";